import axios from 'axios'
import debounce from 'lodash/debounce'

export class BlogArchive {
	constructor() {
		this.activeFiltersEle = document.getElementById('news-active-filters');
		this.baseUrl = document.getElementById('news-archive').dataset.baseUrl;
		this.filters = [];
		this.activeFilterTags = [];

		this.init()
	}

	init() {
		// Trigger Filter setup
		this.setupFilters();

		// Get the params from the URL
		const params = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.get(prop),
		});

		// If there is a category param, then set the active filter
		if ( params.category ) {
			// Check if the category is in the filters
			const filterIndex = this.filters.findIndex(filter => filter.slug === params.category);
			// If found, activate it
			if ( filterIndex >= 0 ) {
				this.filters[filterIndex].el.classList.add('active-recipe');
				this.filters[filterIndex].selected = !this.filters[filterIndex].selected;
			}
			// Render the active filters
			this.renderActiveFilters();
		}
	}

	// Setup the filters based on the HTML that was rendered
	setupFilters() {
		document.querySelectorAll('.news-archive-filter').forEach( blogFilter => {
			const taxonomy = blogFilter.dataset.taxonomy
			const termId = blogFilter.dataset.termId
			const label = blogFilter.dataset.label
			const slug = blogFilter.dataset.slug
			const taxonomyLabel = blogFilter.dataset.taxonomyLabel

			blogFilter.addEventListener('click', () => {
				this.toggleFilter(termId)
			})

			this.filters.push({
				el: blogFilter,
				taxonomy: taxonomy,
				termId: termId,
				selected: false,
				label: label,
				slug: slug,
				taxonomyLabel: taxonomyLabel
			})
		})
	}

	toggleFilter (termId) {
		// Get the toggled filter
		const filterIndex = this.filters.findIndex(filter => filter.termId === termId);
		let toggledFilter = this.filters[filterIndex];

		// If the new filter is a category, then unselect all other active categories
		if ( toggledFilter.taxonomy === 'blogcategory' ) {
			this.filters.forEach(filter => {
				if ( filter.taxonomy === 'blogcategory' && filter.selected && filter.termId !== termId ) {
					filter.selected = false;
					// (DON'T UPDATE DISPLAY UNTIL WE HAVE AJAX)
					// this.removeFilter(filter);
				}
			});
		}

		// Toggle the filter
		toggledFilter.el.classList.toggle('active-recipe');
		toggledFilter.selected = !toggledFilter.selected;

		// Render the active filters
		// (DON'T UPDATE DISPLAY UNTIL WE HAVE AJAX)
		// this.renderActiveFilters();

		// If this filter was removed, then remove the Active Filter Tag as well
		if ( !toggledFilter.selected ) {
			// (DON'T UPDATE DISPLAY UNTIL WE HAVE AJAX)
			// this.removeFilter(filter);
		}

		// Reload the page with the new filters in the query string
		const newFilters = this.filters.filter(filter => filter.selected);
		const newFilterQueryString = (newFilters.length > 0) ? '?'+ newFilters.map(filter => `category=${filter.slug}`).join('&') : '';

		// Go to new URL
		if ( this.baseUrl ) {
			window.open(this.baseUrl + newFilterQueryString, '_self');
		} else {
			window.open(window.location.pathname + newFilterQueryString, '_self'); // Just in case data attribute is not set
		}
	}

	removeFilter (filter) {
		const activeFilterIndex = this.activeFilterTags.findIndex(activeFilterTag => activeFilterTag.termId === filter.termId);
		this.activeFilterTags[activeFilterIndex].el.remove()
		this.activeFilterTags.splice(activeFilterIndex, 1);

		// Also uncheck input
		filter.el.checked = 0;
		filter.el.classList.remove('active-recipe');
	}

	renderActiveFilters() {
		const activeFilters = this.filters.filter(filter => filter.selected);

		activeFilters.forEach(activeFilter => {
			const filterIndex = this.activeFilterTags.findIndex(activeFilterTag => activeFilterTag.termId === activeFilter.termId);

			if (filterIndex < 0) {
				const activeFilterEle = document.createElement('div');
				const activeFilterLabelEle = document.createElement('div');
				const activeFilterTaxonomyLabelEle = document.createElement('div');

				activeFilterEle.classList.add('filter-tags__tag');
				activeFilterLabelEle.classList.add('filter-tags__label');
				activeFilterTaxonomyLabelEle.classList.add('filter-tags__taxonomy-label');

				activeFilterTaxonomyLabelEle.innerHTML = activeFilter.taxonomyLabel + ':';
				activeFilterLabelEle.innerHTML = activeFilter.label + '&nbsp x';

				activeFilterEle.appendChild(activeFilterTaxonomyLabelEle);
				activeFilterEle.appendChild(activeFilterLabelEle);

				this.activeFiltersEle.appendChild(activeFilterEle);

				activeFilterEle.addEventListener('click', () => {
					this.toggleFilter(activeFilter.termId);
				})

				this.activeFilterTags.push({
					el: activeFilterEle,
					termId: activeFilter.termId
				})
			}
		})
	}
}